<div class="category-list">
  <div class="buttonsList">
    <button matButton="elevated" color="primary" *ngIf="!editOrder" (click)="editOrder = true">
      Reihenfolge bearbeiten
    </button>




    <button matButton="elevated" color="primary" *ngIf="editOrder" (click)="saveOrder()">
      Änderungen speichern
    </button>
    <button matButton="elevated" color="warn" *ngIf="editOrder" (click)="cancel()">
      Abbrechen
    </button>

    <button matButton="elevated" color="primary" (click)="showAddForm()" *ngIf="!showNewCategoryForm">
      Neue Kategorie hinzufügen
    </button>
  </div>
  <div *ngFor="let cat of categories; let i = index"
    style="display: inline-flex;  margin: 20px;  width: 50vw;  justify-content: space-between;">
    <app-common-feature-categories-item *ngIf="editIndex !== i" [category]="cat"
      (edit)="onEdit(i)"></app-common-feature-categories-item>
    <div class="arrows" *ngIf="editOrder" class="col2">
      <button matButton="elevated" [class]="isTopOfList(cat) ? '' : 'btn_green'" [disabled]="isTopOfList(cat)"
        (click)="moveCommonFeature(cat, true)" [disableRipple]="true">
        <i class="fa fa-arrow-up" aria-hidden="true"></i>
      </button>
      <button matButton="elevated" [class]="isBottomOfList(cat) ? '' : 'btn_green'" [disabled]="isBottomOfList(cat)"
        (click)="moveCommonFeature(cat, false)" [disableRipple]="true">
        <i class="fa fa-arrow-down" aria-hidden="true"></i>
      </button>
    </div>

  </div>


  <app-common-feature-categories-add *ngIf="showNewCategoryForm" (saved)="addNewCategory($event)"
    (cancel)="cancelAdd()"></app-common-feature-categories-add>
</div>